<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="产品资料批量上传"
      :showFooter="false"
      :innerHeight="600"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-table
        stripe
        :header-cell-style="{backgroundColor: '#F4F8FB'}"
        :data="allTableData"
        border
        height="200px"
      >
        <el-table-column label="文件" prop="files" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-upload
              action=""
              :before-upload="beforeUpload"
              :http-request="handleHttp"
              :show-file-list="false"
              v-if="!scope.row.fileRoute">
              <el-link type="primary" :underline="false" @click="activeRow=scope.$index">
                {{scope.row.fileName ? scope.row.fileName : '上传'}}
              </el-link>
            </el-upload>
            <el-link type="primary" :underline="false" @click="downLoad(scope.row)" v-else>{{scope.row.fileName}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="更新说明" prop="updateInstructions" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="scope.row.updateInstructions" v-if="!scope.row.fileRoute"></el-input>
            <span v-else>{{scope.row.updateInstructions}}</span>
          </template>
        </el-table-column>
        <el-table-column label="上传时间" prop="uploadTime" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.uploadTime|formatDate('YYYY-MM-DD HH:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operator" show-overflow-tooltip width="80px"></el-table-column>
        <el-table-column label="操作" width="80px">
          <template slot-scope="scope">
            <el-link :underline="false" type="primary" @click="save(scope.row)" v-if="!scope.row.isSave">保存</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center; margin: 10px 0;">
        <el-button type="primary" size="small" @click="add" v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$addProductInfomation`">新增</el-button>
      </div>
      <batch-upload-list ref="batchUploadList"></batch-upload-list>
    </q-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import batchUploadList from './batch-upload-list'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  components: {
    batchUploadList
  },
  props: ['visible', 'spuId'],
  data() {
    return {
      // 业务
      tableData: [],
      tempTableData: [],
      activeRow: '',
      isNeedRefresh: false
    }
  },
  computed: {
    ...mapGetters({
      userName: 'name'
    }),
    allTableData() {
      return [...this.tableData, ...this.tempTableData]
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    }
  },
  mounted() {
    // 业务
    // this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      if (this.isNeedRefresh) {
        this.$emit('success');
      }
      this.$emit('close');
    },
    confirm() {
      this.updateVal();
    },
    // 业务
    init() {
      let data = {
        spuId: this.spuId,
        type: '5'
      }
      this.$q.newProduct.queryProductDataCopywriting({params: data})
      .then(res=>{
        this.tableData = res.data;
      })
    },
    add() {
      this.tempTableData.push({
        fileName: '',
        files: null,
        updateInstructions: this.allTableData.length ? '' : '新增',
        uploadTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        timeStamp: moment().format('x'),
        operator: this.userName
      })
    },
    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isLt50M) {
        this.$message.error('上传文件大小不能超过 50MB!');
      }
      return isLt50M;
    },
    handleHttp(file) {
      console.log(file);
      this.tempTableData[this.activeRow - this.tableData.length].files = file.file;
      this.tempTableData[this.activeRow - this.tableData.length].fileName = file.file.name;
    },
    save(row) {
      if(!row.files) {
        this.$message.error('请上传文件');
        return;
      }
      if(!row.updateInstructions) {
        this.$message.error('请填写更新说明');
        return;
      }
      let spuIds = this.$refs['batchUploadList'].flatSelectionData.map(v=>v.spuId);
      if(!spuIds.length || !spuIds) {
        this.$message.error('请选择批量操作对象');
        return;
      }
      // this.tempTableData = this.tempTableData.filter(v=>v.timeStamp !== row.timeStamp)
      let data = {
        spuId: spuIds.join(','),
        updateInstructions: row.updateInstructions,
        uploadTime: row.uploadTime,
        operator: row.operator,
        type: '5',
        files: row.files,
      }
      this.$q.newProduct.newProductArrivalUpload({data}, true)
      .then(res=>{
        if(res.code == 200) {
          this.isNeedRefresh = true;
          this.$message.success('上传成功')
        }else{
          this.$message.error(res.message)
        }
        // this.init();
        this.$set(row, 'isSave', true);
        this.$refs['batchUploadList'].onReset();
      })
    },
    downLoad(row) {
      let url = row.fileRoute;
      let fileName = row.fileName;
      var xhr = new XMLHttpRequest();
      xhr.open("GET",url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement("a");
            var body = document.querySelector("body");

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-upload-list__item:first-child
    margin-top 0px
  >>> .el-upload-list__item
    margin-top 0px
  >>> .el-upload-list__item-name
    margin-right 0px
</style>